export default {"src":"/_next/static/media/patent-bg.dcb1d964.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};